import React from 'react';
import { styled } from 'ps-gui';
import Immutable from 'immutable';

import { formatPhoneNumber } from '../../../modules/utils';
import { getColumnText } from '../../../data/phrases';

export const basicInfoAttrs = [
	'userName',
	'displayName',
	null,
	'email',
	'phone',
];

/**
 * Tato funkce slouží pro správný výběr atributu z objektu informací o profilu.
 * @param {Object} data {@link src/data/mock/userprofile/userprofile.json}
 * @param {String} attr
 * @returns správně parsovaný attribut z objektu, pokud není => null
 */
export function getBasicInfoValue(data, attr) {
	if (!attr) {
		return null;
	}

	let res = data.get(attr);
	if (attr === 'phone') {
		res = formatPhoneNumber(res);
	}
	if (Immutable.List.isList(res)) {
		res = res.join(', ');
	}

	return res || null;
}

export default class ProfileTab extends React.PureComponent {
	render() {
		const {profile} = this.props;

		return <Profile>
			<tbody>
				{
					basicInfoAttrs.map((attr, index) => {
						return (
							<tr key={index} className={!attr ? 'dummy' : ''}>
								<td className="label">{attr ? getColumnText(attr, 'userProfile') : null}</td>
								<td className="value">{getBasicInfoValue(profile, attr)}</td>
							</tr>
						);
					})
				}
			</tbody>
		</Profile>;}
}

const Profile = styled.table`
	tr {
		&.dummy {
			height: 32px;
		}
		td {
			color: ${props => props.theme.disabledTextColor};
			&.label {
				padding: 4px;
				font-size: 16px;
				font-weight: 700;
				min-width: 200px;
			}
			&.value {
				font-size: 16px;
				font-weight: 400;
			}
		}
	}
`;